import {afterNextRender, Component, computed, effect, inject, OnInit, PLATFORM_ID} from '@angular/core';
import {ParkingHeroComponent} from './parking-components/parking-hero/parking-hero.component';
import {ParkingChallangesComponent} from './parking-components/parking-challanges/parking-challanges.component';
import {ParkingOfferComponent} from './parking-components/parking-offer/parking-offer.component';
import {ParkingAboutComponent} from './parking-components/parking-about/parking-about.component';
import {ParkingFormComponent} from './parking-components/parking-form/parking-form.component';
import {ParkingLocationComponent} from './parking-components/parking-location/parking-location.component';
import {FooterComponent} from '../shared/component/footer/footer.component';
import {ParkingStepsComponent} from './parking-components/parking-steps/parking-steps.component';
import {ParkingLogisitcsComponent} from './parking-components/parking-logisitcs/parking-logisitcs.component';
import {ComponentMetadata} from '../shared/model/component-metadata.model';
import {landingSectionsSignal} from '../shared/signal/common/landing-sections.signal';
import {AbstractLandingComponent} from '../shared/component/abstract/abstract-landing.component';
import {SectionDirective} from '../shared/directive/section.directive';
import {formComponentSignal} from '../shared/signal/common/form-component.signal';
import {MicrosoftClarityService} from '../shared/analytics/microsoft/microsoft-clarity.service';
import {isPlatformBrowser} from '@angular/common';
import {utmResolver} from '../shared/resolver/utm.resolver';
import {GoogleAnalyticsService} from '../shared/analytics/google/google-analytics.service';
import {AnalyticsEventCategory, AnalyticsEventName} from '../shared/enum/gtm-cookie-consent.enum';
import {routingMetadata} from '../shared/signal/common/routing-matadata.signal';

@Component({
  selector: 'app-parking',
  imports: [
    ParkingHeroComponent,
    ParkingChallangesComponent,
    ParkingOfferComponent,
    ParkingAboutComponent,
    ParkingFormComponent,
    ParkingLocationComponent,
    FooterComponent,
    ParkingStepsComponent,
    ParkingLogisitcsComponent,
    SectionDirective,

  ],
  templateUrl: './parking.component.html',
  styleUrl: './parking.component.scss'
})
export class ParkingComponent extends AbstractLandingComponent implements OnInit {
  public readonly isBrowser = isPlatformBrowser(inject(PLATFORM_ID));
  protected readonly computedSections = computed<ComponentMetadata[]>(() => landingSectionsSignal());
  private readonly pageTitle = computed(() => routingMetadata().label || 'ProcessWay AutoPark')
  private readonly locale = $localize.locale || 'pl-PL';

  constructor(
    private readonly microsoftClarityService: MicrosoftClarityService,
    private readonly googleAnalyticsService: GoogleAnalyticsService,
  ) {
    super();

    effect(() => {
      const sections = this.computedSections();
      if (!sections?.length) return;

      const formSection = sections.find(s => s.id === 'application-form');

      formComponentSignal.set(formSection);
    });

    this.registerMicrosoftClaritySessionMeta();
  }

  public ngOnInit(): void {
    if (this.isBrowser) {
      this.trackPageViewEvent();
    }
  }

  private trackPageViewEvent(): void {
    this.googleAnalyticsService.trackEvent({
      event: AnalyticsEventName.PageView,
      eventCategory: AnalyticsEventCategory.RouteEvent,
      eventPayload: {
        page_location: window.location.href,
        language: this.locale,
        page_title: this.pageTitle()
      }
    });
  }

  private registerMicrosoftClaritySessionMeta(): void {
    afterNextRender(() => {
      this.microsoftClarityService.identify('autopark', undefined, undefined, 'Autopark Landing');
      this.microsoftClarityService.setTag('variant', 'auctions');

      const utm = utmResolver('utm_source');

      if (utm) {
        this.microsoftClarityService.setTag('utm_source', utm);
      }
    });
  }
}
